import { GeoCoordinateInput, Query } from '@varo/graphql-schema-types';
import QueryPartnerOffersDetails from 'services/graphql/queries/PartnerOfferDetails.query';
import { useQuery } from 'urql';

import { useRewardsLocation } from './useRewardsLocation';

const usePartnerOffersDetails = (
  offerId: string,
  overrideCoordinates?: GeoCoordinateInput,
) => {
  const { coords: deviceLocation } = useRewardsLocation();

  const location = overrideCoordinates ?? deviceLocation;

  const variables = {
    id: offerId,
    location,
  };

  const [{ data, fetching: loading, error, stale }] = useQuery<Query>({
    query: QueryPartnerOffersDetails,
    variables,
    requestPolicy: 'cache-and-network',
  });

  return {
    offer: data?.myPartnerOffers?.offer,
    loading,
    error,
    stale,
  };
};

export default usePartnerOffersDetails;
